import FormattedText from "../../FormattedText/FormattedText";
import {
  BackButton,
  HeadingPersuasionWrapper,
  HeroTitle,
  HeroTitleBlock,
  PromoStrip,
} from "../Styles";
import { HeadingPersuasion } from "./HeadingPersuasion";

interface HeroBarProps {
  title?: unknown;
  headingPersuasion?: { stats?: unknown; icon?: string };
  promoText?: unknown;
  hasHeadingPersuasion: boolean;
}

/**
 * Reusable hero title + persuasion/promo strip used in both the
 * static hero and the scroll-locked sticky header.
 */
export const HeroBar = ({
  title,
  headingPersuasion,
  promoText,
  hasHeadingPersuasion,
}: HeroBarProps) => (
  <>
    <HeroTitleBlock>
      <BackButton onClick={() => window.history.back()} aria-label="Go back" />
      <HeroTitle>
        <FormattedText value={title || "Common Landing"} />
      </HeroTitle>
    </HeroTitleBlock>
    {hasHeadingPersuasion ? (
      <HeadingPersuasionWrapper>
        <HeadingPersuasion headingPersuasion={headingPersuasion} />
      </HeadingPersuasionWrapper>
    ) : promoText ? (
      <PromoStrip>
        <FormattedText value={promoText} />
      </PromoStrip>
    ) : null}
  </>
);
